import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FaIconComponent, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'ml-list-loading-overlay',
  templateUrl: './list-loading-overlay.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent],
})
export class ListLoadingOverlayComponent implements ILoadingOverlayAngularComp {
  private readonly library = inject(FaIconLibrary);

  constructor() {
    this.library.addIcons(faCircleNotch);
  }

  // Required by ILoadingOverlayAngularComp interface - no initialization needed
  agInit(): void {
    // Intentionally empty - component uses template only
  }
}
